import React, { useEffect, useState } from 'react'


import { loadUsers, deleteUser, loadJuries, loadAdministrators } from '../utils/Network'
import { Link } from 'react-router-dom';
import CountryName from '../components/CountryName';

function listInitial(item) {
    const fn = item.first_name && String(item.first_name).trim();
    const ln = item.last_name && String(item.last_name).trim();
    const em = item.email && String(item.email).trim();
    const name = fn || ln || em || '?';
    return name.charAt(0).toUpperCase();
}

function hslBackgroundForId(id) {
    const n = Number(id) || 0;
    const h = (n * 47) % 360;
    return `hsl(${h}, 55%, 42%)`;
}

export default function AdministratorsContent({page}) {

    if(!page)
        page = 1;
    const [loading, setLoading] = useState(0);

    const [users, setUsers] = useState(null);
    const [next, setNext] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [pages, setPages] = useState(null);
    const [count, setCount] = useState(null);
    const [show_delete, setShowDelete] = useState(false);

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    useEffect(() => {
        loadAdministrators(page).then(data => {
            console.log(data)
            setCount(data.count)
            var page_count = parseInt(data.count / 10)+1;
            var pages_array = page_count>0 ? range(1, page_count) : [];
            setPages(pages_array);
            setNext(data.next);
            setPrevious(data.previous);

            if (data.results)
                setUsers(data.results);
        });
    }, []);

    function range(start, end) {
        return Array.apply(0, Array(end ))
            .map((element, index) => index + start);
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteUser(id).then(data=> {
            console.log(data)
            // loadUsers().then(users => {
            //     setUsers(users);
            // });
        })
    }


    return (
      <>
        <div className="content-wrapper">
          <section className="content-header" style={{ maxWidth: '1550px' }}>
            <h3 className="box-title mt-5"></h3>
            <ol className="breadcrumb">
              <li>
                <a href="/cms">
                  <i className="fa fa-dashboard"></i> Home
                </a>
              </li>
              <li className="active">Administrators</li>
            </ol>
          </section>

          <section className="content">
            <div className="container-fluid" style={{ maxWidth: '1400px' }}>
            <div className="row">
              <div className="col-md-12">
                <div className="box box-primary">
                  <div className="box-header with-border">
                    <h3 className="box-title">
                      All administrators
                      {count != null && (
                        <span style={{ fontSize: 11, marginLeft: '0.35em' }}>({count})</span>
                      )}
                    </h3>
                    <a href="/cms/administrator" title="Add New" className="btn btn-cm margin-r-5 pull-right">
                      <i className="fa fa-plus"></i>
                    </a>
                    <button type="button" title="Show Delete Button" className="btn btn-cm margin-r-5 pull-right" onClick={showDelete}>
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                  <div className="box-body no-padding">
                    <table
                      id="example1"
                      className="table table-striped"
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th className="hide-on-small">Gender</th>
                          <th className="hide-on-small">POB</th>
                          <th>Registered</th>
                          <th style={{ width: 70 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {users &&
                          users.map((item) => (
                            <tr
                              key={item.id}
                              className={loading === item.id ? "loading" : ""}
                            >
                              <td>
                                <div className="img-container">
                                  <a href={`/cms/administrator/${item.id}`}>
                                    {item.image ? (
                                      <img
                                        src={item.image}
                                        className="pull-left img-list img-circle margin-r-10"
                                        alt=""
                                      />
                                    ) : (
                                      <div
                                        className="pull-left img-list img-circle margin-r-10 users-letter-avatar"
                                        style={{ backgroundColor: hslBackgroundForId(item.user || item.id) }}
                                        aria-hidden
                                      >
                                        {listInitial(item)}
                                      </div>
                                    )}
                                  </a>
                                </div>

                                <a href={`/cms/administrator/${item.id}`} className="link-color">
                                    {item.first_name && (
                                    <p className="text-capitalize mb-0 text-light">
                                      {item.first_name} {item.last_name}
                                    </p>
                                  )}
                                  {!item.first_name && (
                                    <p className="text-light">{item.email}</p>
                                  )}
                                </a>
                              </td>

                              <td className="hide-on-small">
                                {item.gender === 0
                                  ? "Male"
                                  : item.gender === 1
                                  ? "Female"
                                  : "Other"}
                              </td>
                              <td className="hide-on-small">
                                <CountryName id={item.country} /> {item.city_id}
                              </td>
                              <td className="font-size-12">
                                {item.created_at &&
                                  item.created_at.split(" ")[0]}{" "}
                                <br />
                                {item.created_at &&
                                  item.created_at.split(" ").length > 1 &&
                                  item.created_at.split(" ")[1].split(".")[0]}
                              </td>
                              <td>
                                <div className="d-flex" style={{ gap: '6px' }}>
                                  {show_delete && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        if (window.confirm("Are you sure you wish to delete this item?"))
                                          handleDelete(item.id, e);
                                      }}
                                      className="btn btn-cm btn-sm"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                  <a href={`/cms/administrator/${item.id}`} className="btn btn-cm btn-sm">
                                    <i className="fa fa-eye"></i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th>Name</th>
                          <th className="hide-on-small">Gender</th>
                          <th className="hide-on-small">POB</th>
                          <th>Registered</th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                {pages && pages.length > 1 &&
                  <ul className="pagination cms-pagination m-0 float-right">
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        «
                      </Link>
                    </li>
                    {pages &&
                      pages.map((page_number) => (
                        <li key={page_number} className="page-item">
                          <a
                            className={
                              page_number == page
                                ? "page-link active"
                                : "page-link"
                            }
                            href={`administrators/${page_number}`}
                          >
                            {page_number}
                          </a>
                        </li>
                      ))}
                    <li className="page-item">
                      <Link className="page-link" to="">
                        »
                      </Link>
                    </li>
                  </ul>
                }
              </div>
            </div>
            </div>
          </section>
        </div>
      </>
    );
}
